import * as yup from "yup";

import { FormId } from "../../../../../components/enums";
import {
  policeDepartmentValidatorRequired,
  radioValidator,
  statementCaseNumberValidator,
} from "../../../../../utilities/validators";
import { trimmedString } from "../../../../../utilities/validators/trimmedString";

import { ComponentId } from "./enums";

export const validator = {
  [FormId.INCIDENT_STATEMENTS]: yup.object({
    [ComponentId.TYPE]: radioValidator,
    [ComponentId.POLICE_DEPARTMENT]: trimmedString.onlyIfFieldIsVisible(
      policeDepartmentValidatorRequired
    ),
    [ComponentId.CASE_NUMBER]: trimmedString.onlyIfFieldIsVisible(
      statementCaseNumberValidator
    ),
  }),
};
